export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_WITH_TIME_FORMAT = 'DD.MM.YYYY, HH:mm';
export const DATE_API_FORMAT = 'YYYY-MM-DD';

export const DEFAULT_TIME_ZONE = 'Asia/Krasnoyarsk';
export const MOSCOW_ZONE = 'Europe/Moscow';
